import { Injectable } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AppMainService } from 'src/app/app-main.service';
import { SalesOrderService } from 'src/app/inventory/sales-order/sales-order.service';
import { Status } from 'src/app/opportunities-v2/model/opportunity.enum';

@Injectable({
  providedIn: 'root'
})
export class QuotationStatusToggleService {

  constructor(
    private appMainService: AppMainService,
    private messageService: MessageService,
    private salesOrderService: SalesOrderService,private confirmationService: ConfirmationService,

) {}


updateQuotationStatus(status: string, selectedQuotation: any): Promise<void> {
  return new Promise((resolve, reject) => {
      this.confirmationService.confirm({
          message: `Do you want to ${status} this Quotation?`,
          header: 'Confirmation',
          icon: 'pi pi-info-circle',
          accept: () => {
              this.appMainService.isShowSpinner("changeStatus");
              this.salesOrderService.getEstimatesDetailsById(selectedQuotation?.id).subscribe({
                  next: (resp) => {
                      if (resp.statusId === Status.Active) {
                          resp.statusId = Status.InActive;
                      } else if (resp.statusId === Status.InActive) {
                          resp.statusId = Status.Active;
                      }
                      delete resp.warehouse;
                      delete resp.contact;
                      delete resp.account;
                      delete resp.paymentMethod;
                      delete resp.paymentTerm;
                      delete resp.shippingMethod;
                      delete resp.tax;

                      this.updateEstimate(resp)
                          .then(() => {
                              resolve();
                          })
                          .catch((err) => {
                              reject(err);
                          })
                          .finally(() => {
                              this.appMainService.isHideSpinner("changeStatus");
                          });
                  },
                  error: (err) => {
                      this.appMainService.isHideSpinner("changeStatus");
                      this.messageService.add({
                          severity: "error",
                          summary: "Error",
                          detail: "Error occurred...",
                      });
                      reject(err);
                  },
              });
          },
          reject: () => {
          },
      });
  });
}



updateEstimate(customattributeList: any): Promise<void> {
  return new Promise((resolve, reject) => {
      this.appMainService.isShowSpinner("loadEstimate");
      this.salesOrderService
          .editEstimate(customattributeList)
          .then(() => {
              this.appMainService.isHideSpinner("loadEstimate");
              this.messageService.add({
                  severity: "success",
                  summary: "Success",
                  detail: "Estimate updated successfully...",
              });
              resolve();
          })
          .catch(() => {
              this.appMainService.isHideSpinner("loadEstimate");
              this.messageService.add({
                  severity: "error",
                  summary: "Error",
                  detail: "Error occurred while updating data...",
              });
              reject();
          });
  });
}

}
